import { MessageType, MouseActionType } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';

/** PC_APPBUTTON, KEYBOARD_CTRLED_ALTED_SEND or KEYBOARD_POST MessageTypes */
export class KeyEventMessage extends BaseMessage {
    protected key: number;
    protected status: number;

    constructor(messageType: (MessageType.PC_APPBUTTON | MessageType.KEYBOARD_CTRLED_ALTED_SEND | MessageType.KEYBOARD_POST),
        key: number,
        status?: number) {
        super();
        this.key = key;
        this.status = status ?? 0;
        this.header.command = messageType;
    }

    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeInt32LE(this.key);
        buffer.writeInt32LE(this.status);
    }
}

/** KEYBOARD_SEND MessageType */
export class SkinKeyEventMessage extends BaseMessage {
    protected key: number;
    protected status: number;

    constructor(key: number, status: number) {
        super();
        this.key = key;
        this.status = status;
        this.header.command = MessageType.KEYBOARD_SEND;
    }

    public serializeBody(buffer: MemoryBuffer) {
        buffer.writeInt16LE(this.key);
        buffer.writeInt16LE(this.status);
    }
}

/** MOUSE MessageType */
export class MouseEventMessage extends BaseMessage {
    private type: MouseActionType;
    private xValue: number;
    private yValue: number;

    constructor(type: MouseActionType, xValue: number, yValue: number) {
        super();
        this.type = type;
        this.xValue = xValue;
        this.yValue = yValue;
        this.header.command = MessageType.MOUSE;
    }
    public serializeBody(buffer: MemoryBuffer) {
        // console.log("createMouseEventMessage: x = " + this.xValue + ", y = " + this.yValue);
        buffer.writeUInt8(this.type);
        buffer.writeUInt8(this.xValue >> 8);
        buffer.writeUInt8(this.xValue & 255);
        buffer.writeUInt8(this.yValue >> 8);
        buffer.writeUInt8(this.yValue & 255);
    }
}
